

import { Grid, TextField, InputAdornment, IconButton } from '@material-ui/core'
import React from 'react'
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

function Input({ name, handleChange, errorManage, label, half, autoFocus, type, value, handleShowPassword, reference }) {
    return (
        <Grid item xs={12} sm={half ? 6 : 12}>
            <TextField
                name={name}
                label={label}
                fullWidth
                required
                value={value[name]}
                onChange={handleChange}
                autoFocus={autoFocus}
                type={type}
                ref = {reference}
        
                error={errorManage[name].errorFunction(value) ? true : null}
                helperText={errorManage[name].errorFunction(value) ? errorManage[name].errorMessage : null}

                InputProps={name === 'password' || name === 'confirmPassword' ? {

                    endAdornment: (
                        <InputAdornment position='end'>
                            <IconButton onClick={handleShowPassword}>
                                {type === "password" ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    )

                } : null}
            />

        </Grid>

    )
}

export default Input;
